export enum UipathConnectionType {
    onPremise='OnPremise',
    cloud='Cloud'
}

export enum RpaType {
  uipath='Uipath',
  aae='Aae',
  bluePrism='BluePrism'
}

export enum AuthType {
  apiAccess = 'ApiAccess',
  clientCredentials = 'ClientCredentials'
}

export enum ConstAuthClientCredentials {
  grantType = 'client_credentials',
  authUrl = 'https://cloud.uipath.com/identity_/connect/token',
  scope = 'OR.Execution OR.Jobs OR.Queues OR.Robots.Read OR.Folders.Read'
}
